module.exports = __webpack_public_path__ + "img/maskformarket.8f7e9bda.png";